import React from "react";
import { useSelector } from "react-redux";
import { State } from "store";
import polyLogo from "../assets/images/poly_logo.svg";
import polyLogoOrange from "assets/images/poly_logo_orange.svg";

export const PolyLogoFooter: React.FC = () => {
  const theme = useSelector((state: State) => state.userMeta.theme);
  return (
    <div className="footer-bottom-centered">
      {theme !== "DARK" ? (
        <img src={polyLogo} alt="Poly" data-testid="poly-logo" />
      ) : (
        <img src={polyLogoOrange} alt="Poly" data-testid="poly-logo" />
      )}
    </div>
  );
};
